var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TeamForm',{attrs:{"originalEditingTeam":_vm.editingTeam},on:{"clearOriginalEditingTeam":function($event){_vm.editingTeam = null}}}),_c('TeamsOverview',{on:{"editTeam":function($event){_vm.editingTeam = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }